<div class="right-panel configSettings h-100">
  <div class="settingsPanel" name='storageConfigForm' [formGroup]="storageConfigForm">
    <div class="settingRow" *ngFor="let param of configParameters">
      <span class="settingTitle"
        >{{ param.parameterName }} :
        
      </span>
      <input
        *ngIf="param?.parameterTypeBoolean != 'true'"
        formControlName="{{ param.parameterName }}"
        value="{{ param.parameterValue }}"
        type="text"
      />
      <select
        name="{{ param.parameterName }}"
        formControlName="{{ param.parameterName }}"
        *ngIf="param?.parameterTypeBoolean == 'true'"
      >
        <option value="True">Enable</option>
        <option value="False">Disable</option></select
      ><br />

      <span
        *ngIf="param.parameterDescription"
        class="bi bi-info-circle-fill synchpc-primary infoIconConfig"
        placement="bottom"
        container="body"
        triggers="hover" [ngbTooltip]="syncHpcTooltips"
      ></span>

      <ng-template #syncHpcTooltips>
        <p>{{ param.parameterDescription }}</p></ng-template
      >
    </div>
  </div>
  <div class="bottom-panel">
    <button *ngIf="isMonitor == false" (click)="redirectTo()" class="default-btn" style="width: 5%;"><span class="bi bi-arrow-left" aria-hidden="true" style="margin-right: 15%;"></span>Back</button>
    <button *ngIf="isMonitor == false" (click)="onSave(storageConfigForm)" class="default-btn" style="margin-right: 3%; width: 5%;">
      <span class="bi bi-save" aria-hidden="true" style="margin-right: 15%;"></span>Save
      </button>
  </div>
</div>

